import { useSelector } from "react-redux";
import { AppState } from "../RootReducer";
import { ReactNode } from "react-markdown";
import { getAppContext } from "../selectors/settings-selectors";
import { AppContext, AppMode } from "../http/protocol";
import { t } from "../i18n";
import { BrandA } from "../ui/buttons/buttons";
import { isDevEnv } from "../utils/utils";

const MINI_PROGRAM_APP_ID = "2170020209617595";
const GLIFE_APP_LINK = `https://gcash${isDevEnv() ? "dev" : "app"}.page.link/?link=https://gcash.splashscreen/?redirect%3Dgcash%3A%2F%2Fcom.mynt.gcash%2Fapp%2F006300121300%3FappId%253D${MINI_PROGRAM_APP_ID}`;

const GlifeContextWithdraw = ({ children }: { children: ReactNode }) => {
  const appContext = useSelector((app: AppState) => getAppContext(app));
  const appMode = useSelector((app: AppState) => app.user.appMode);
  const isGlifeInBrowser = appContext === AppContext.GLIFE && appMode === AppMode.NONE;

  if (!isGlifeInBrowser) return <>{children}</>;

  return (
    <div className="p-5 withdraw-cta-container">
      <p>{t("glife.withdraw.cta-info")}</p>
      <BrandA href={GLIFE_APP_LINK} className={"btn btn-cta large"}>
        {t("glife.withdraw.cta-button")}
      </BrandA>
    </div>
  );
};

export default GlifeContextWithdraw;
